import "./contact-us-question-box.styles.css";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { SiGmail } from "react-icons/si";
import {
  FaTelegramPlane,
  FaWhatsapp,
  FaPhoneAlt,
  FaInstagramSquare,
} from "react-icons/fa";

const ContactUsQuestionBox = ({ cat }) => {
  return (
    <div className="contact-us-question-box">
      <h3 className="contact-us-question-box-title">
        چطور با ما ارتباط بگیرید ؟
      </h3>

      {cat.email && (
        <p className="contact-detail">
          <span className="contact-details-icon">
            <SiGmail />
          </span>{" "}
          {cat.email}
        </p>
      )}

      {cat.address && (
        <p className="contact-detail">
          <span className="contact-details-icon">
            <FaLocationDot />
          </span>{" "}
          {cat.address}
        </p>
      )}

      {cat.number && (
        <p className="contact-detail">
          <span className="contact-details-icon">
            <BsFillTelephoneFill />
          </span>{" "}
          {cat.number}
          {/* Telegram Icon */}
          <a
            href="https://t.me/youngstoring"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <FaTelegramPlane className="contact-details-icon telegram-icon" />
          </a>
          {/* WhatsApp Icon */}
          <a
            href="https://wa.me/989108794329"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <FaWhatsapp className="contact-details-icon whatsapp-icon" />
          </a>
          {/* Call Icon (Opens Dialer) */}
          <a href="tel:0910" className="contact-link">
            <FaPhoneAlt className="contact-details-icon call-icon" />
          </a>
        </p>
      )}

      {cat.instagram && (
        <p className="contact-detail">
          {/* Instagram Icon */}
          <a
            href="https://www.instagram.com/youngstoring"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <FaInstagramSquare className="contact-details-icon instagram-icon" />
          </a>

          {/* Instagram Text as a Link */}
          <a
            href="https://www.instagram.com/youngstoring"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link instagram-text"
          >
            {cat.instagram}
          </a>
        </p>
      )}
    </div>
  );
};

export default ContactUsQuestionBox;
